import { render, staticRenderFns } from "./touzhe.vue?vue&type=template&id=3ce1f330&scoped=true"
import script from "./touzhe.vue?vue&type=script&lang=js"
export * from "./touzhe.vue?vue&type=script&lang=js"
import style0 from "./touzhe.vue?vue&type=style&index=0&id=3ce1f330&prod&lang=scss&scoped=true"
import style1 from "./touzhe.vue?vue&type=style&index=1&id=3ce1f330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1f330",
  null
  
)

export default component.exports